<div class="overlay" *ngIf="result" (click)="close()">
  <div class="dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h3>Target Audience</h3>
      <button class="close-x" (click)="close()">&times;</button>
    </div>
    <p class="summary">
      <strong>{{ result.total }} recipient(s)</strong> after inclusions/exclusions:
    </p>
    <div class="people-box">
      <div class="person-row" *ngFor="let p of result.people">
        <strong>{{ p.display_name }}</strong> — {{ p.email }}
        <div class="meta" *ngIf="meta(p)">{{ meta(p) }}</div>
      </div>
      <div class="empty-hint" *ngIf="result.people.length === 0">No recipients found.</div>
    </div>
    <button class="close-btn" (click)="close()">Close</button>
  </div>
</div>